import { Button, DefaultTheme, Select, ThemeProps } from "@deliverr/ui";
import { ModalTemplate } from "@deliverr/ui-facility";
import styled from "@emotion/styled";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { TrailerType } from "@deliverr/sortation-client";
import { TrailerCloseoutModal } from "./TrailerCloseoutModal";

interface IProps {
  bolId: string;
  trailerId: string;
  sealNumber: string;
  onConfirm: (trailerType: TrailerType) => void;
}

const trailerTypeOptions = [
  { value: TrailerType.BOX_TRUCK, label: "Box Truck" },
  { value: TrailerType.DRY_VAN, label: "Dry Van" },
];

const ButtonContainer = styled.div<{}, DefaultTheme>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.S3};
`;

const TrailerTypeFormContainer = styled.div<ThemeProps>(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.S2};
  margin-bottom: ${theme.spacing.S3};
  text-align: left;
`
);

export const TrailerTypeSelectionModal: React.FC<IProps> = ({ bolId, trailerId, sealNumber, onConfirm }) => {
  const { hideModal } = useSortationModal();
  const [trailerType, setTrailerType] = useState<TrailerType>();

  const handleTrailerTypeChange = (option) => {
    setTrailerType(option.value);
  };

  const handleConfirm = () => {
    if (trailerType) {
      onConfirm(trailerType);
    }
  };

  return (
    <ModalTemplate
      buttonLayout={"column"}
      title={
        <FormattedMessage
          id="sortation.trailerCloseout.trailerType.header"
          defaultMessage="Select Trailer Type for BOL {bolId}"
          values={{ bolId }}
        />
      }
    >
      <TrailerTypeFormContainer>
        <div>
          <strong>BOL ID:</strong> {bolId}
        </div>
        <div>
          <strong>Trailer ID:</strong> {trailerId}
        </div>
        <div>
          <strong>Seal Number:</strong> {sealNumber}
        </div>
        <Select
          label="Trailer Type"
          value={trailerTypeOptions.find((opt) => opt.value === trailerType)}
          options={trailerTypeOptions}
          onChange={handleTrailerTypeChange}
        />
      </TrailerTypeFormContainer>

      <ButtonContainer>
        <Button block onClick={handleConfirm} disabled={!trailerType}>
          <FormattedMessage id="sortation.trailerCloseout.trailerType.confirm" defaultMessage="Confirm Closeout" />
        </Button>
        <Button block onClick={() => hideModal(TrailerCloseoutModal.TRAILER_TYPE_SELECTION)} secondary>
          <FormattedMessage id="sortation.trailerCloseout.trailerType.cancel" defaultMessage="Cancel" />
        </Button>
      </ButtonContainer>
    </ModalTemplate>
  );
};
